import findAncestor from "./findAncestor";
import dispatch from "./dispatch";

export default () => {

    const icons = document.querySelectorAll('[data-icon-tab-icon]');

    function openTab(tab) {
        const content = tab.querySelector('[data-icon-tab-content]');
        const rect = content.getBoundingClientRect();
        const height = rect.height;
        tab.style.marginBottom = height + 'px';
        tab.classList.add('active');
        content.classList.add('active');
        window.setTimeout(() => {
            dispatch('domchanged');
        }, 400);
    }

    function closeTab(tab) {
        const content = tab.querySelector('[data-icon-tab-content]');
        tab.classList.remove('active');
        content.classList.remove('active');
        tab.style.marginBottom = '48px';

        window.setTimeout(() => {
            dispatch('domchanged');
        }, 400);
    }

    for (const icon of icons) {

        icon.addEventListener('click', () => {

            const tab = findAncestor(icon, '[data-icon-tab]');
            const grid = findAncestor(icon, '[data-icon-grid]');
            if (tab.classList.contains('active')) {
                closeTab(tab);
            } else {
                const activeTab = grid.querySelector('.active[data-icon-tab]');
                if (activeTab) {
                    closeTab(activeTab);
                    window.setTimeout(() => {
                        openTab(tab);
                    }, 10);
                } else {
                    openTab(tab);
                }
            }

        });

    }

}
